import { formatVisiblePhoneNumber } from '../../utils/mask/phone';

export function formatValue(value = '', isNumberFieldType, isPhoneNumberField) {
  if (isNumberFieldType && value === 0) {
    return '';
  }

  if (isPhoneNumberField) {
    return formatVisiblePhoneNumber(value.toString());
  }

  return value;
}



// WEBPACK FOOTER //
// ./src/components/TextInput/utils.js